import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import { ResponsiveSpacingType } from '@fiverr-private/theme/src/components/Box/types';
import { fluidSectionClass } from './styles.ve.css';

interface FluidSectionProps {
  children: React.ReactNode;
  paddingTop?: ResponsiveSpacingType;
  paddingBottom?: ResponsiveSpacingType;
  className?: string;
}

const FluidSection: React.FC<FluidSectionProps> = ({ children, paddingTop, paddingBottom, className }) => (
  <Container
    as="section"
    width="100%"
    paddingTop={paddingTop}
    paddingBottom={paddingBottom}
    paddingLeft={{
      default: '5',
      sm: '8',
      xl: '12',
    }}
    paddingRight={{
      default: '0',
      md: '8',
      xl: '12',
    }}
    className={`${fluidSectionClass} ${className || ''}`}
  >
    {children}
  </Container>
);

export default FluidSection;
